import { render, staticRenderFns } from "./SolicitarRevisao.vue?vue&type=template&id=15f41ca3&lang=pug&"
import script from "./SolicitarRevisao.vue?vue&type=script&lang=js&"
export * from "./SolicitarRevisao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports